import { render, staticRenderFns } from "./TicketFlowChart.vue?vue&type=template&id=5b5574b0&scoped=true&"
import script from "./TicketFlowChart.vue?vue&type=script&lang=js&"
export * from "./TicketFlowChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5574b0",
  null
  
)

export default component.exports